var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCarbonRuleFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4971 1.25H3.99714C3.66562 1.25 3.34767 1.3817 3.11325 1.61612C2.87883 1.85054 2.74714 2.16848 2.74714 2.5V10.625C2.74567 11.8715 3.08374 13.0948 3.72503 14.1637C4.36633 15.2325 5.28663 16.1066 6.38714 16.6919L10.2471 18.75L14.1071 16.6919C15.2076 16.1066 16.1279 15.2325 16.7692 14.1637C17.4105 13.0948 17.7486 11.8715 17.7471 10.625V2.5C17.7471 2.16848 17.6154 1.85054 17.381 1.61612C17.1466 1.3817 16.8287 1.25 16.4971 1.25ZM14.6221 11.25H5.87214V10H14.6221V11.25ZM14.6221 7.5H5.87214V6.25H14.6221V7.5Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarbonRuleFilled);
export default __webpack_public_path__ + "static/media/carbon_rule-filled.c36b9c969ff12023eaef710417e31099.svg";
export { ForwardRef as ReactComponent };